export default "__VITE_ASSET__BoLFf1ju__"